/**
 * SA-1033 (UX pass ruling Q5), SA-1079: the potential-duplicate chip's words,
 * for the triage row that birthed the record and (UX pass 3) the record
 * strip. Compare only, opening the record's Queue section; no Merge until
 * SA-1030's matching decides what a merge means on a group-born record.
 */
import { formatConfidence } from '@/components/process/proposalText'

export const COMPARE = 'Compare'

export function duplicateChipText(fact: { ofNumber: string; score: number }): string {
  const percent = formatConfidence(fact.score)
  return percent ? `possible duplicate of ${fact.ofNumber} · ${percent}` : `possible duplicate of ${fact.ofNumber}`
}

/** The record with its Queue section focused (`?panel=queue`, SA-461). */
export function compareHref(recordId: string): string {
  return `/orders?order=${recordId}&panel=queue`
}

/** SA-1034 PR 5 (spec §3.1): the chip's tip — where the score came from and what Compare opens. */
export function duplicateChipTitle(fact: { ofNumber: string; score: number }): string {
  const percent = formatConfidence(fact.score)
  const scored = percent ? `Scored ${percent} against ${fact.ofNumber}` : `Scored against ${fact.ofNumber}`
  return `${scored} by the duplicate check at intake · Compare opens the Queue section`
}
